// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3M0oH","ranges":"BmiRanges_ranges__1TKBI"};